import { library } from "@common/library/library";
import { actionStore } from "@common/actionStore";
import { recordStore } from "@common/recordStore";

let componentBoilerplate = function (params) {
    const { component, template } = params;
    return {
        template: template,
        data() {
            return {
                templateData: {}, // A place to put custom, local, template-specific settings
                // component: component,
            };
        },
        props: {
            hovered: {
                type: Boolean,
                default: false
            },
            targeted: {
                type: Boolean,
                default: false
            },
            record: {
                type: Object,
                default() {
                    return {};
                }
            },
            itemRecords: {
                type: Array,
                default() {
                    return [];
                }
            },
            index: {}
        },
        computed: {
            moment() {
                return library.getMomentObj();
            },
            actionStore() {
                return actionStore;
            },
            records() {
                return recordStore().records;
            },
            volId() {
                return component.contextVolId;
            },
            user() {
                return component.user;
            },
            oppId() {
                return component.contextOppId || component.oppId;
            },
            orgId() {
                return component.contextOrgId || component.orgId;
            },
            aeId() {
                return component.contextAeId || component.aeId;
            },
            entryPointId() {
                return component.contextEntryPointId || component.entryPointId;
            },
            affId() {
                return component.contextAffId || component.affId;
            },
            schId() {
                return component.contextSchId || component.schId;
            },
            lbeId() {
                return component.contextLbeId || component.lbeId;
            }
        },
        methods: {
            trimHTML(str) {
                return library.trimHTML(str);
            },
            dateDetails(dateStr, formatStr) {
                let momentDate = library.getMoment(dateStr, formatStr);
                return {
                    D: momentDate.format('D'),
                    MMM: momentDate.format('MMM'),
                    dddd: momentDate.format('dddd'),
                };
            },
            toggleDelay(time, property) {
                this.templateData[property] = !this.templateData[property];
                setTimeout(() => {
                    this.templateData[property] = !this.templateData[property];
                }, parseInt(time, 10));
            }
        }
    };
};

class GenerateComponent {
    static registeredComponents = new Map();

    constructor(_this, template, cType, cIndex = 0) {
        this.cTemplate = GenerateComponent.validateTemplate(template);
        this.cId = GenerateComponent.generateTemplateId(cType, cIndex, this.cTemplate, _this.cId);
        GenerateComponent.generateComponent(_this, this.cId, this.cTemplate);
    }

    static generateTemplateId(type, index, template, parentId = 0) {
        const existingTemplate = GenerateComponent.compareTemplates(template);
        return existingTemplate || `activity_step_panel_${parentId}_${type}_${index}`;
    }

    static validateTemplate(template) {
        if (!template) return template;
        let res = library.validateHTML(template);
        if (!res.valid) {
            return `<div>(Invalid Template)</div>`;
        }
        return `<div>${template}</div>`;
    }

    static compareTemplates(template) {
        for (const key of GenerateComponent.registeredComponents.keys()) {
            if (GenerateComponent.registeredComponents.get(key).template === template) return key;
        }
        return false;
    }

    static generateComponent(parentComponent, cId, template) {
        if (GenerateComponent.registeredComponents.has(cId)) return cId;
        vueApp.component(cId, componentBoilerplate({ component: parentComponent, template }));

        GenerateComponent.registeredComponents.set(cId, {
            template: template,
        });
        return cId;
    }

    // TODO: Create a way to deregister components if they are not used anymore.
}

export { GenerateComponent };
